const clamp = (num, min = Number.NEGATIVE_INFINITY, max = Number.POSITIVE_INFINITY) => Math.min(Math.max(num, min), max);
const cycle = (num, min, max) => {
  if (num < min) {
    return max;
  }
  if (num > max) {
    return min;
  }
  return num;
};
const getNumberOfDigits = (num) => Math.ceil(Math.log10(num + 1));
const AMPMHoursToMilitary = (hours, period) => {
  if (!hours || period === "AM" && hours !== "12" || period === "PM" && hours === "12") {
    return hours;
  }
  if (period === "AM" && hours === "12") {
    return "00";
  }
  return (parseInt(hours, 10) + 12).toString();
};
const isAM = (hours) => !hours || parseInt(hours, 10) < 12;
const formatAMPMHours = (rawHours) => rawHours && (parseInt(rawHours, 10) % 12 || 12).toString().padStart(2, "0");
function serialize(rawHours, minutes, period = "AM", use24Hours = true) {
  const hours = use24Hours ? rawHours : AMPMHoursToMilitary(rawHours, period);
  return [hours, minutes, "00"].join(":");
}
function deserialize(value, use24Hours) {
  if (!value) {
    return {
      hours: "",
      minutes: "",
      period: "AM",
      seconds: "00"
    };
  }
  const [rawHours, minutes, seconds] = value.split(":");
  return {
    period: isAM(rawHours) ? "AM" : "PM",
    hours: use24Hours ? rawHours : formatAMPMHours(rawHours),
    minutes,
    seconds
  };
}
const formatRawHours = (hours, use24Hours) => {
  if (hours) {
    const intHours = parseInt(hours, 10);
    if (use24Hours) {
      return clamp(intHours, 0, 23).toString().padStart(2, "0");
    }
    if (intHours > 24) {
      return "12";
    }
    return formatAMPMHours(hours);
  }
  return hours;
};
export {
  clamp,
  cycle,
  deserialize,
  formatRawHours,
  getNumberOfDigits,
  serialize
};
//# sourceMappingURL=helpers.js.map
